module.exports = __webpack_public_path__ + "img/home_know_more_img_02_shadow.b43c0873.png";